module.exports = __webpack_public_path__ + "static/img/applyImg.7690d503.png";